/* RESPONSIBLE TEAM: team-phone */
import type ForwardCall from 'embercom/models/operator/visual-builder/step/forward-call';
import StepConfig, { type StepConfigParams } from '../step';

export default class ForwardCallConfiguration extends StepConfig {
  declare step: ForwardCall;

  constructor(params: Omit<StepConfigParams, 'component'> & { component?: string }) {
    super({
      component: 'workflows/graph-editor/node-items/steps/forward-call',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
